/**
 * Front-door rules (Maciek 23.10): the main address goes back to login-only on every site, and
 * the new homepage lives at /home on the developer sites only, until it is ready to go public.
 *
 * UX ONLY (Convention 29): these decide what the browser renders. They hide pages from casual
 * visitors and crawlers that follow links; anyone who types an address still gets the page.
 */

/** What "/" does. Unchanged from before the homepage existed. */
export type RootRoute = 'onboarding_router' | 'coming_soon' | 'signup' | 'login';

export function rootRouteFor(hasSession: boolean, productionGated: boolean, hasAccessInvite: boolean): RootRoute {
  if (hasSession) return 'onboarding_router';
  if (productionGated) return 'coming_soon';
  return hasAccessInvite ? 'signup' : 'login';
}

/**
 * The marketing footer links into Społeczność and search. A logged-out visitor on gated
 * production sees only the coming-soon splash, so the footer must not give them a way in.
 */
export function footerVisibleFor(hasSession: boolean, productionGated: boolean): boolean {
  return hasSession || !productionGated;
}
